import PhotoSwipeLightbox from 'photoswipe/lightbox';

// Helpers
import './helpers/lazy.js';

// Globals
import { setCookie, deleteCookie } from './helpers/func.js';
import { MOBILE_BREAKPOINT } from "./config.js";

function initMobileSubmenus() {
  const menuItems = document.querySelectorAll( '.menu-item-has-children' );

  if ( !menuItems.length ) return;

  const toggleButtons = new Map();

  menuItems.forEach( item => {
    const btn = document.createElement( 'button' );
    btn.classList.add( 'submenu-toggle' );
    btn.setAttribute( 'aria-expanded', 'false' );
    btn.setAttribute( 'aria-label', 'Rozwiń podmenu' );
    btn.innerHTML = '<span></span>';
    item.appendChild( btn );
    toggleButtons.set( item, btn );

    btn.addEventListener( 'click', ( e ) => {
      e.preventDefault();
      e.stopPropagation();

      const subMenu = item.querySelector( '.sub-menu' );
      if ( !subMenu ) return;

      const isActive = subMenu.classList.contains( 'active' );

      // Zamknij inne otwarte submenu
      menuItems.forEach( otherItem => {
        const otherSub = otherItem.querySelector( '.sub-menu' );
        const otherBtn = toggleButtons.get( otherItem );
        if ( otherSub && otherItem !== item ) {
          otherSub.classList.remove( 'active' );
          otherBtn?.setAttribute( 'aria-expanded', 'false' );
        }
      } );

      subMenu.classList.toggle( 'active', !isActive );
      btn.setAttribute( 'aria-expanded', String( !isActive ) );
    } );
  } );

  const handleResize = () => {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    toggleButtons.forEach( ( btn ) => {
      btn.style.display = isMobile ? '' : 'none';
    } );

    // Na desktopie zamknij wszystkie otwarte submenu
    if ( !isMobile ) {
      menuItems.forEach( item => {
        const subMenu = item.querySelector( '.sub-menu' );
        const btn = toggleButtons.get( item );
        subMenu?.classList.remove( 'active' );
        btn?.setAttribute( 'aria-expanded', 'false' );
      } );
    }
  };

  window.addEventListener( 'resize', handleResize );
  handleResize();
}

document.addEventListener( 'DOMContentLoaded', function () {

  const accessibilityPanel = document.querySelector( '.accesibility' );
  const accessibilityWrapper = document.querySelector( '.accesibility__actions' );
  const accessibilityTrigger = accessibilityPanel?.querySelector( '.accesibility__trigger' );
  const themeColorMeta = document.querySelector( 'meta[name="theme-color"]' );

  const updateThemeButtons = ( activeTheme ) => {
    if ( !accessibilityWrapper ) return;

    [ 'theme-default', 'theme-contrast' ].forEach( className => {
      const button = accessibilityWrapper.querySelector( `.${className}` );
      if ( !button ) return;

      const isActive = className === `theme-${activeTheme}`;
      button.classList.toggle( 'is-active', isActive );
      button.setAttribute( 'aria-pressed', String( isActive ) );
    } );
  };

  const updateFontButtons = ( activeFont ) => {
    if ( !accessibilityWrapper ) return;

    [ 'font-normal', 'font-large', 'font-xlarge' ].forEach( className => {
      const button = accessibilityWrapper.querySelector( `.${className}` );
      if ( !button ) return;

      const isActive = className === activeFont;
      button.classList.toggle( 'is-active', isActive );
      button.setAttribute( 'aria-pressed', String( isActive ) );
    } );
  };

  const setTheme = ( theme ) => {
    const isContrast = theme === 'contrast';

    document.documentElement.classList.toggle( 'contrast', isContrast );
    document.documentElement.classList.toggle( 'default', !isContrast );

    if ( isContrast ) {
      setCookie( 'color-scheme', 'contrast', 365, '/' );
    } else {
      deleteCookie( 'color-scheme', '/' );
    }

    if ( themeColorMeta ) {
      themeColorMeta.setAttribute( 'content', isContrast ? '#000000' : '#F1F0F0' );
    }

    updateThemeButtons( theme );
  };

  const setFontSize = ( className, size ) => {
    document.documentElement.style.fontSize = size;
    document.documentElement.setAttribute( 'data-font-size', className );
    document.cookie = `font-size=${className}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
    updateFontButtons( className );
  };

  if ( accessibilityPanel && accessibilityTrigger ) {
    accessibilityTrigger.addEventListener( 'click', function () {
      const isOpen = accessibilityPanel.classList.toggle( 'active' );
      accessibilityTrigger.setAttribute( 'aria-expanded', String( isOpen ) );
    } );

    document.addEventListener( 'click', ( event ) => {
      if ( accessibilityPanel.contains( event.target ) ) return;

      accessibilityPanel.classList.remove( 'active' );
      accessibilityTrigger.setAttribute( 'aria-expanded', 'false' );
    } );

    document.addEventListener( 'keydown', ( event ) => {
      if ( event.key !== 'Escape' ) return;

      accessibilityPanel.classList.remove( 'active' );
      accessibilityTrigger.setAttribute( 'aria-expanded', 'false' );
    } );
  }

  // Mobile menu
  const mobileMenuTrigger = document.getElementById( 'MobileMenuTrigger' );
  initMobileSubmenus();

  if ( mobileMenuTrigger ) {
    mobileMenuTrigger.addEventListener( 'click', () => {
      document.body.classList.toggle( 'mobile-menu-active' );
    } );
  }

  if (accessibilityWrapper) {
    const fontTriggers = {
      'font-normal': '100%',
      'font-large': '120%',
      'font-xlarge': '140%'
    };

    Object.entries(fontTriggers).forEach(([className, size]) => {
      const btn = accessibilityWrapper.querySelector(`.${className}`);
      if (btn) {
        btn.addEventListener('click', () => {
          setFontSize( className, size );
        });
      }
    });

    accessibilityWrapper.querySelector( '.theme-contrast' )?.addEventListener( 'click', function () {
      setTheme( 'contrast' );
    } );

    accessibilityWrapper.querySelector( '.theme-default' )?.addEventListener( 'click', function () {
      setTheme( 'default' );
    } );

    updateFontButtons( document.documentElement.getAttribute( 'data-font-size' ) || 'font-normal' );
    updateThemeButtons( document.documentElement.classList.contains( 'contrast' ) ? 'contrast' : 'default' );
  }

  // Tickets floating button behavior
  const heroSection = document.querySelector( '.hero' );
  const floatingTickets = document.querySelector( '.floating_tickets' );

  // Etykieta zwija się do ikonki chwilę po pojawieniu się przycisku (styl tylko na mobile).
  // Przy chowaniu stan etykiety zostaje bez zmian, żeby przycisk nie zmieniał szerokości w trakcie animacji.
  let ticketsCollapseTimeout = null;

  const showFloatingTickets = () => {
    floatingTickets.classList.remove( 'is-collapsed' );
    floatingTickets.classList.add( 'active' );

    clearTimeout( ticketsCollapseTimeout );
    ticketsCollapseTimeout = setTimeout( () => {
      floatingTickets.classList.add( 'is-collapsed' );
    }, 2000 );
  };

  const hideFloatingTickets = () => {
    clearTimeout( ticketsCollapseTimeout );
    floatingTickets.classList.remove( 'active' );
  };

  if ( floatingTickets && floatingTickets.classList.contains( 'active' ) ) {
    showFloatingTickets();
  }

  if ( heroSection && floatingTickets ) {
    const observer = new IntersectionObserver(
      ( entries ) => {
        entries.forEach( ( entry ) => {
          if ( entry.isIntersecting ) {
            hideFloatingTickets();
          } else {
            showFloatingTickets();
          }
        } );
      },
      {
        threshold: 0,
        rootMargin: '0px'
      }
    );

    observer.observe( heroSection );
  }

  initPhotoSwipe();
  initEventFilters();

} );

function initPhotoSwipe() {
  const galleries = document.querySelectorAll( '.js-gallery' );

  if ( !galleries.length ) return;

  galleries.forEach( gallery => {
    const pswpGallery = gallery.classList.contains( 'pswp-gallery' )
      ? gallery
      : gallery.querySelector( '.pswp-gallery' );

    if ( !pswpGallery ) return;

    const lightbox = new PhotoSwipeLightbox( {
      gallery: pswpGallery,
      children: 'a',
      pswpModule: () => import('photoswipe')
    } );

    lightbox.init();
  } );
}

function initEventFilters() {
  const typeFilter = document.getElementById( 'event-type-filter' );
  const placeFilter = document.getElementById( 'event-place-filter' );

  if ( !typeFilter && !placeFilter ) return;

  const applyFilters = () => {
    const params = new URLSearchParams( window.location.search );

    if ( typeFilter ) {
      const typeValue = typeFilter.value;
      if ( typeValue ) {
        params.set( 'filter_type', typeValue );
      } else {
        params.delete( 'filter_type' );
      }
    }

    if ( placeFilter ) {
      const placeValue = placeFilter.value;
      if ( placeValue ) {
        params.set( 'filter_place', placeValue );
      } else {
        params.delete( 'filter_place' );
      }
    }

    // Reset to first page when filtering
    params.delete( 'paged' );

    const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.location.href = newUrl;
  };

  if ( typeFilter ) {
    typeFilter.addEventListener( 'change', applyFilters );
  }

  if ( placeFilter ) {
    placeFilter.addEventListener( 'change', applyFilters );
  }

}
